import { configureStore } from "@reduxjs/toolkit";
import { API } from "./services/api.js";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import accountReducer from "./features/account/accountSlice.js";

export const store = configureStore({
    reducer: {
        // Add the generated reducer as a specific top-level slice
        [API.reducerPath]: API.reducer,
        account: accountReducer,
    },
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat([API.middleware]),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
